import { z } from "zod/mini"

const TimestampConfigSchema = z.object({
	label: z.nullish(z.string()),
	placeholder: z.optional(z.string()),
	default: z.optional(z.string()),
})

export const TimestampModelSchema = z.object({
	type: z.literal("Timestamp"),
	fieldset: z.nullish(z.string()),
	config: z.optional(TimestampConfigSchema),
})

export type TimestampModel = z.infer<typeof TimestampModelSchema>
